import { Entity, LiveData } from '@toeverything/infra';

import type { DocRecord, DocsService } from '../../doc';
import type { TemplateDocListStore } from '../store/list';

/**
 * Check if a template title should be filtered out.
 * Filters out meeting-related templates EXCEPT "1:1 Meeting".
 */
function shouldFilterMeetingTemplate(title: string): boolean {
  const lowerTitle = title.toLowerCase();
  // Keep "1:1 Meeting" template
  if (lowerTitle === '1:1 meeting') {
    return false;
  }
  // Filter out any other templates containing "meeting" or "meetings"
  return lowerTitle.includes('meeting');
}

export class TemplateDocList extends Entity {
  constructor(
    public listStore: TemplateDocListStore,
    public docsService: DocsService
  ) {
    super();
  }

  public isTemplate$(docId: string) {
    return LiveData.from(this.listStore.watchTemplateDoc(docId), false);
  }

  public getTemplateDocs() {
    return this.listStore
      .getTemplateDocIds()
      .map(id => this.docsService.list.doc$(id).value)
      .filter((doc): doc is DocRecord => {
        if (!doc || doc.trash$.value) {
          return false;
        }
        // Filter out meeting-related templates (except 1:1 Meeting)
        const title = doc.title$.value || '';
        if (shouldFilterMeetingTemplate(title)) {
          return false;
        }
        return true;
      });
  }
}
